<template>
    <div>
        <div>
            <div class="d-flex flex-column flex-md-row">
                <ol class="breadcrumb bg-white px-0 pt-1 pb-2 mr-auto">
                    <li class="breadcrumb-item"><a href="#" @click.stop="setFolder(scope, null)">{{ getScopeName() }}</a></li>
                    <li class="breadcrumb-item" v-for="item in breadcrumbs" :key="item.id"><a href="#" @click.stop="setFolder(scope, item.id)">{{ item.label }}</a></li>
                </ol>
                <div class="pb-2" v-if="scope != 'selected'">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <input type="checkbox" v-model="checkall" @click="checkAll()" :title="$t('[[[Zaznacz wszystkie]]]')" />
                            </div>
                        </div>
                        <select class="custom-select" v-model="sort" @change="emitSort(sort)">
                            <option v-for="(option, index) in sortOptions" :key="index" :value="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="tpl-thumbs" v-if="template == 'thumbs'">
            <draggable v-model="sortable" :options="{draggable: '.draggable'}" :move="canSort" class="d-flex flex-wrap pt-2 border-top">
                <div v-for="item in resources" :key="`${item.resourceType}:${item.id}`" class="draggable order-1 pr-2">
                    <div class="thumb pointer noselect" :class="{'selected': isSelected(item), 'inactive': disabled(item)}" @click="select(item, $event)" @dblclick="execute(item, $event)">
                        <b-img :src="item.url | image('thumb')" class="img" blank-color="#777" :alt="item.name" v-if="item.isImage" />
                        <i class="fa fa-fw fa-5x mt-3" :class="getIcon(item)" v-if="!item.isImage"></i>
                        <input type="checkbox" :data-id="item.id" :checked="isChecked(item)" @click.stop="check(item)" :disabled="disabled(item)" />
                        <div class="caption">{{ item.name }}</div>
                    </div>
                </div>
                <div class="order-0 pr-2" slot="footer" :class="{'inactive': media !== 'files'}" v-if="breadcrumbs.length > 0">
                    <div class="thumb pointer noselect" @dblclick="goUp()">
                        <i class="fa fa-fw fa-folder-open fa-5x mt-3"></i>
                        <div class="caption">..</div>
                    </div>
                </div>
            </draggable>
        </div>

        <table class="table table-hover mb-0" v-if="template == 'list'">
            <colgroup>
                <col width="40">
                <col>
            </colgroup>
            <tbody v-if="breadcrumbs.length > 0">
                <tr class="pointer noselect" :class="{'inactive': media !== 'files'}" @dblclick="goUp()">
                    <td></td>
                    <td class="p-0">
                        <div class="d-flex pt-2 pb-2">
                            <div class="pr-2">
                                <i class="fa fa-fw fa-folder-open fa-3x mt-1"></i>
                            </div>
                            <div class="mr-auto">
                                <h5>..</h5>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
            <draggable :element="'tbody'" v-model="sortable" :move="canSort">
                <tr v-for="item in resources" :key="`${item.resourceType}:${item.id}`" class="pointer noselect" :class="{'table-info': isSelected(item), 'inactive': disabled(item)}" @click="select(item, $event)" @dblclick="execute(item, $event)">
                    <td>
                        <input type="checkbox" :data-id="item.id" :checked="isChecked(item)" @click.stop="check(item)" :disabled="disabled(item)" />
                    </td>
                    <td class="p-0">
                        <div class="d-flex pt-2 pb-2">
                            <div class="pr-2">
                                <b-img :src="item.url | image('thumb')" width="54" height="54" blank-color="#777" :alt="item.name" thumbnail v-if="item.isImage" />
                                <i class="fa fa-fw fa-3x mt-1" :class="getIcon(item)" v-if="!item.isImage"></i>
                            </div>
                            <div class="mr-auto">
                                <h5>{{ item.name }}</h5>
                                <div class="d-flex flex-column flex-xl-row">
                                    <div class="pr-4">
                                        <span class="text-primary">{{ $t('[[[Data dodania]]]') }}: </span><span>{{ item.dateCreatedUtc | datetime }}</span>
                                    </div>
                                    <div class="pr-4">
                                        <span class="text-primary">{{ $t('[[[Data modyfikacji]]]') }}: </span><span>{{ item.dateModifiedUtc | datetime }}</span>
                                    </div>
                                    <div class="pr-4" v-if="item.resourceType == 'file'">
                                        <span class="text-primary">{{ $t('[[[Rozmiar]]]') }}: </span><span>{{ item.contentLength | filesize }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </draggable>
        </table>

        <table class="table table-hover mb-0" v-if="template == 'table'">
            <colgroup>
                <col width="40">
                <col width="10">
                <col>
                <col width="100">
                <col width="170">
                <col width="170">
            </colgroup>
            <tbody>
                <tr class="pointer noselect" :class="{'inactive': media !== 'files'}" v-if="breadcrumbs.length > 0" @dblclick="goUp()">
                    <td></td>
                    <td class="p-0 pt-2"><i class="fa fa-fw fa-folder-open fa-2x"></i></td>
                    <td>..</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
            <draggable :element="'tbody'" v-model="sortable" :move="canSort">
                <tr v-for="item in resources" :key="`${item.resourceType}:${item.id}`" class="pointer noselect" :class="{'table-info': isSelected(item), 'inactive': disabled(item)}" @click="select(item, $event)" @dblclick="execute(item, $event)">
                    <td>
                        <input type="checkbox" :data-id="item.id" :checked="isChecked(item)" @click.stop="check(item);" :disabled="disabled(item)" />
                    </td>
                    <td class="p-0 pt-2"><i class="fa fa-fw fa-2x" :class="getIcon(item)"></i></td>
                    <td>{{ item.name }}</td>
                    <td class="text-nowrap text-right"><span v-if="item.resourceType == 'file'">{{ item.contentLength | filesize }}</span></td>
                    <td class="text-nowrap"><i class="far fa-clock" :title="$t('[[[Data dodania]]]')"></i> {{ item.dateCreatedUtc | datetime }}</td>
                    <td class="text-nowrap"><i class="fas fa-clock" :title="$t('[[[Data modyfikacji]]]')"></i> {{ item.dateModifiedUtc | datetime }}</td>
                </tr>
            </draggable>
        </table>

        <div v-if="resources.length == 0">
            <div class="text-center">
                {{ $t('[[[Nie znaleziono żadnych plików]]]') }}
            </div>
        </div>

        <div class="alert alert-secondary text-center pointer mb-0" v-if="this.pager.getPageIndex() < this.pager.getTotalPages()" @click="loadMore()">
            {{ $t('[[[pokaż więcej...]]]') }}
        </div>
    </div>
</template>

<script>
import some from 'lodash/some';
import draggable from 'vuedraggable';

export default {
    name: 'filemanager-files',
    components: {
        draggable
    },
    props: {
        'scope': {
            type: String,
            required: true,
            default: 'public'
        },
        'media': {
            type: String,
            default: 'files'
        },
        'template': {
            type: String,
            required: true,
            default: 'thumbs'
        },
        'breadcrumbs': {
            type: Array,
            required: true
        },
        'resources': {
            type: Array,
            required: true
        },
        'selected': {
            required: true
        },
        'checked': {
            type: Array,
            required: true
        },
        'pager': {
            type: Object,
            required: true
        }
    },
    data: function()
    {
        return {
            checkall: false,
            sortOptions: [
                { value: { column: 'name', order: 'asc' }, text: this.$t('▲ [[[Nazwa katalogu lub pliku]]]') },
                { value: { column: 'name', order: 'desc' }, text: this.$t('▼ [[[Nazwa katalogu lub pliku]]]') },
                { value: { column: 'size', order: 'asc' }, text: this.$t('▲ [[[Rozmiar]]]') },
                { value: { column: 'size', order: 'desc' }, text: this.$t('▼ [[[Rozmiar]]]') },
                { value: { column: 'dateCreatedUtc', order: 'asc' }, text: this.$t('▲ [[[Data dodania]]]') },
                { value: { column: 'dateCreatedUtc', order: 'desc' }, text: this.$t('▼ [[[Data dodania]]]') },
                { value: { column: 'dateModifiedUtc', order: 'asc' }, text: this.$t('▲ [[[Data modyfikacji]]]') },
                { value: { column: 'dateModifiedUtc', order: 'desc' }, text: this.$t('▼ [[[Data modyfikacji]]]') }
            ],
            sort: {
                column: 'name',
                order: 'asc'
            }
        };
    },
    methods: {
        getScopeName()
        {
            switch (this.scope)
            {
                case "public": return this.$t('[[[Pliki publiczne]]]');
                case "private": return this.$t('[[[Pliki prywatne]]]');
                default: return this.$t('[[[Wybrane pliki]]]');
            }
        },
        setFolder(scope, folder)
        {
            if (scope !== 'selected')
            {
                this.checkall = false;

                this.$emit('change-folder', {
                    scope: scope,
                    folder: folder
                });
            }
        },
        emitSort(sort)
        {
            this.$emit('sort-order', sort);
        },
        setOrder(column)
        {
            let order = 'asc';

            if (this.sort.column === column)
            {
                order = this.sort.order === 'asc' ? 'desc' : 'asc';
            }

            this.sort = {
                column: column,
                order: order
            };

            this.emitSort(this.sort);
        },
        sortIcon(column)
        {
            return this.sort.column === column
                ? this.sort.order === 'asc'
                    ? 'fa fa-sort-up'
                    : 'fa fa-sort-down'
                : 'fa fa-sort';
        },
        check(item)
        {
            if (!this.disabled(item))
            {
                this.checkall = false;
                this.$emit('check-item', item);
            }
        },
        isChecked(item)
        {
            return some(this.checked, p => p.resourceType === item.resourceType && p.id === item.id);
        },
        checkAll()
        {
            this.$emit('check-all', (this.checkall = !this.checkall));
        },
        goUp()
        {
            this.setFolder(this.scope, this.breadcrumbs.length > 1 ? this.breadcrumbs[this.breadcrumbs.length - 2].id : null);
        },
        execute(item, e)
        {
            this.select(item, e);

            if (item.resourceType === 'file' && this.checked.length === 0 && !this.disabled(item))
            {
                this.$events.$emit('filemanager-callback-value', [item]);
            }
            if (item.resourceType === 'folder')
            {
                this.setFolder(this.scope, item.id);
            }
        },
        loadMore()
        {
            this.$emit('more');
        },
        select(item, e)
        {
            if (e.ctrlKey)
                this.check(item);
            else
                this.$emit('select-item', item);
        },
        isSelected(item)
        {
            return this.selected && this.selected.resourceType === item.resourceType && this.selected.id === item.id;
        },
        getIcon(item)
        {
            if (item.resourceType === "folder")
            {
                return "fa fa-folder";
            }
            switch (item.contentType)
            {
                case 'image/jpeg': return 'far fa-file-image';
                case 'image/png': return 'far fa-file-image';
                case 'video/mp4': return 'far fa-file-video';
                case 'application/msword': return 'far fa-file-word';
                case 'application/vnd.ms-excel': return 'far fa-file-excel';
                case 'application/vnd.ms-powerpoint': return 'far fa-file-powerpoint';
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return 'far fa-file-word';
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return 'far fa-file-excel';
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation': return 'far fa-file-powerpoint';
                case 'application/pdf': return 'far fa-file-pdf';
                case 'application/zip': return 'far fa-file-archive';
                case 'application/octet-stream': return 'far fa-file';
                default: return 'far fa-file';
            }
        },
        canSort()
        {
            return this.scope === 'selected';
        },
        disabled(item)
        {
            return this.media !== "files" && item.media.indexOf(this.media) === -1;
        }
    },
    computed: {
        sortable: {
            get()
            {
                return this.resources;
            },
            set(value)
            {
                this.$emit('sorted', value);
            }
        }
    },
    watch: {
        resources: function()
        {
            this.checkall = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.col {
    padding: 0 4px 0 4px;
}
.space {
    padding: 0 4px;
    min-width: 110px;
}
.thumb {
    position: relative;
    padding: 4px;
    min-width: 110px;
    height: 110px;
    margin: 0 0 26px 0;
    border: 1px solid #ddd;
    background-color: #fff;
    text-align: center;

    input[type="checkbox"] {
        position: absolute;
        left: 4px;
        bottom: 3px;
    }
    .img {
        max-width: 100px;
        max-height: 100px;
    }
    .caption {
        position: absolute;
        left: -1px;
        right: -1px;
        top: 108px;
        height: 20px;
        padding: 3px 2px 4px 2px;
        word-wrap: break-word;
        text-align: center;
        line-height: 1;
        overflow: hidden;
        border: 1px solid transparent;
        border-top: 0;
    }
}
.tpl-thumbs .selected {
    border: 1px solid #20a8d8;
    background-color: #67c2ef;

    .caption {
        overflow: visible;
        height: auto;
        border: 1px solid #20a8d8;
        border-top: 0;
        background-color: #67c2ef;
        color: #ffffff;
        z-index: 990;
    }
}
.table tbody + tbody {
    border-top-width: 1px;
}
.inactive {
    opacity: 0.5;
}
</style>
